import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose, withHandlers } from 'recompose';
import { get } from 'lodash';
import FetchOnMount from '../../hoc/FetchOnMount';
import Barbers from '../../barbers/components/Barbers';
import { fetchShop } from '../../shops/actions';
import { getShopByRoute } from '../../shops/selectors';
import { fetchShopAvailability } from '../../times/actions';
import {
  fetchBarbers,
} from '../../barbers/actions';
import { getAvailableTimeBarbers } from './selectors';
import { parseTimeSlug, generateUrlString } from '../../utils/helpers';
import config from '../../../config';


const mapStateToProps = (state, ownProps) => ({
  barbers: getAvailableTimeBarbers(state, ownProps.params),
  shop: getShopByRoute(state, ownProps.params.shopRoute),
  generateUrlString: params => generateUrlString({ ...ownProps.params, ...params }, ownProps.urlPattern),
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const parsedTime = parseTimeSlug(
    get(ownProps, 'params.reservationTime'),
  );
  const startDay = parsedTime && parsedTime.format(config.apiDateFormat);

  return bindActionCreators({
    fetchShop: fetchShop.bind(null, ownProps.params.shopRoute, ownProps.urlPattern),
    fetchAvailability: fetchShopAvailability.bind(null, ownProps.params.shopRoute, startDay),
    fetchBarbers: fetchBarbers.bind(
      null,
      ownProps.params.shopRoute,
      ownProps.params,
      ownProps.urlPattern
    ),
  }, dispatch);
};

const fetchData = withHandlers({
  fetchData: props => () => props.fetchShop()
    .then(() => props.fetchAvailability())
    .then(() => props.fetchBarbers()),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  fetchData,
  FetchOnMount,
)(Barbers);



// WEBPACK FOOTER //
// ./src/app/dynamicBooking/time/Barbers.js